export const STUDIO_WHITE_LABEL_FEATURE = 'studio-white-label';
